const CITIES = {
  FLORIANOPOLIS: "4205407",
};

export { CITIES };
